import React, { useState } from "react"
import { Link } from "gatsby"
import styled from "styled-components"
import { menuData } from "../data/menuData"
import MenuButton from "../buttons/MenuButton"
import MenuTooltips from "../tooltips/MenuTooltips"
import { LogoHeading, tagLine } from "../Styles/TextStyles"
import DividerWithText from "../Styles/DividerWithText"

function Header() {
  const [isOpen] = useState(false)

  return (
    <Outer>
      <Wrapper>
        <Link to="/">
          <TextWrapper>
            <Text>PRO INC.</Text>
          </TextWrapper>
        </Link>
        <DividerWithText>
          <TagLine>Be the Proficient</TagLine>
        </DividerWithText>
        <MenuWrapper count={menuData.length}>
          {menuData.map((item, index) => (
            <MenuButton key={index} item={item} />
          ))}
        </MenuWrapper>
        <MenuTooltips isOpen={isOpen} />
      </Wrapper>
    </Outer>
  )
}

export default Header

const Outer = styled.div`
  position: absolute;
  top: 10px;
  width: 100%;
  align-items: center;
  z-index: 20;
`

const TagLine = styled(tagLine)`
  text-align: center;
  color: #000000;
`

const Text = styled(LogoHeading)`
  font-size: 50px;
  text-align: center;
  color: rgb(0, 255, 255);
  color: #ffffff;
`

const TextWrapper = styled.div``

const Wrapper = styled.div`
  position: absolute;
  top: 25px;
  grid-template-rows: auto auto auto;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 100px;
`

const MenuWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.count}, auto);
  gap: 10px;
  align-items: center;
  align-content: center;
  align-self: center;
`
